import {
	DatePicker,
	FILTER_CONTROL_HEIGHT_CLASS,
	FilterBar,
	FilterClearButton,
	FilterField,
	Input,
} from "@components";
import { getLocalTimeZone, today } from "@internationalized/date";
import type { DateValue } from "react-aria";
import { parseCalendarDateFromString } from "../utils/date-value-helpers";

export type RankingFiltersProps = {
	startDate: DateValue;
	endDate: DateValue;
	searchInput: string;
	onStartDateChange: (date: DateValue) => void;
	onEndDateChange: (date: DateValue) => void;
	onSearchInputChange: (value: string) => void;
	onClear: () => void;
	showClearFilters?: boolean;
};

const SEARCH_INPUT_ID = "ranking-search";
const SEARCH_PLACEHOLDER = "Buscar por nome ou placa";

export function RankingFilters({
	startDate,
	endDate,
	searchInput,
	onStartDateChange,
	onEndDateChange,
	onSearchInputChange,
	onClear,
	showClearFilters = false,
}: RankingFiltersProps) {
	return (
		<FilterBar
			actions={
				showClearFilters ? <FilterClearButton onClick={onClear} /> : null
			}
			className="mb-0"
			label="Filtros do ranking"
		>
			<FilterField label="Data inicial">
				<DatePicker
					aria-label="Data inicial"
					className="w-full"
					maxValue={endDate}
					onChange={(date) => {
						if (date) {
							onStartDateChange(date);
						}
					}}
					size="sm"
					value={parseCalendarDateFromString(startDate?.toString() ?? null)}
				/>
			</FilterField>

			<FilterField label="Data final">
				<DatePicker
					aria-label="Data final"
					className="w-full"
					maxValue={today(getLocalTimeZone())}
					minValue={startDate}
					onChange={(date) => {
						if (date) {
							onEndDateChange(date);
						}
					}}
					size="sm"
					value={parseCalendarDateFromString(endDate?.toString() ?? null)}
				/>
			</FilterField>

			<FilterField
				className="sm:max-w-[600px]"
				grow
				htmlFor={SEARCH_INPUT_ID}
				label={SEARCH_PLACEHOLDER}
				labelVisibility="hidden"
			>
				<Input
					className={FILTER_CONTROL_HEIGHT_CLASS}
					id={SEARCH_INPUT_ID}
					maxLength={80}
					onChange={(e) => {
						onSearchInputChange(e.target.value);
					}}
					placeholder={SEARCH_PLACEHOLDER}
					value={searchInput}
				/>
			</FilterField>
		</FilterBar>
	);
}
